import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightConnectExistingClickedEventName = 'FREIGHT_CONNECT_EXISTING_CLICKED';

export type FreightProviderTrackingSlug = 'worldwide-express' | 'unishippers' | 'unknown';

export const useTrackFreightConnectExistingClicked = (): ((provider: FreightProviderTrackingSlug) => void) => {
  return useCallback((provider: FreightProviderTrackingSlug) => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightConnectExistingClickedEventName, { env: environment, provider });
  }, []);
};
